const PALETTE = [
  { bg: 'bg-sky-50', text: 'text-sky-900', border: 'border-sky-300', dot: 'bg-sky-500', bar: 'from-sky-500 to-cyan-500' },
  { bg: 'bg-teal-50', text: 'text-teal-900', border: 'border-teal-300', dot: 'bg-teal-500', bar: 'from-teal-500 to-emerald-500' },
  { bg: 'bg-indigo-50', text: 'text-indigo-900', border: 'border-indigo-300', dot: 'bg-indigo-500', bar: 'from-indigo-500 to-violet-500' },
  { bg: 'bg-cyan-50', text: 'text-cyan-900', border: 'border-cyan-300', dot: 'bg-cyan-500', bar: 'from-cyan-500 to-sky-500' },
  { bg: 'bg-violet-50', text: 'text-violet-900', border: 'border-violet-300', dot: 'bg-violet-500', bar: 'from-violet-500 to-fuchsia-500' },
  { bg: 'bg-emerald-50', text: 'text-emerald-900', border: 'border-emerald-300', dot: 'bg-emerald-500', bar: 'from-emerald-500 to-teal-500' },
  { bg: 'bg-blue-50', text: 'text-blue-900', border: 'border-blue-300', dot: 'bg-blue-500', bar: 'from-blue-500 to-indigo-500' },
  { bg: 'bg-fuchsia-50', text: 'text-fuchsia-900', border: 'border-fuchsia-300', dot: 'bg-fuchsia-500', bar: 'from-fuchsia-500 to-pink-500' },
  { bg: 'bg-lime-50', text: 'text-lime-900', border: 'border-lime-300', dot: 'bg-lime-500', bar: 'from-lime-500 to-emerald-500' },
  { bg: 'bg-purple-50', text: 'text-purple-900', border: 'border-purple-300', dot: 'bg-purple-500', bar: 'from-purple-500 to-indigo-500' },
  { bg: 'bg-rose-50', text: 'text-rose-900', border: 'border-rose-300', dot: 'bg-rose-500', bar: 'from-rose-500 to-orange-500' },
  { bg: 'bg-amber-50', text: 'text-amber-900', border: 'border-amber-300', dot: 'bg-amber-500', bar: 'from-amber-500 to-yellow-500' },
];

export const TERM_GRADIENTS = [
  'from-sky-600 to-cyan-500',
  'from-teal-600 to-emerald-500',
  'from-indigo-600 to-violet-500',
  'from-blue-700 to-sky-500',
];

export const termGradient = (term) => {
  const n = parseInt(String(term).replace(/\D/g, ''), 10);
  return TERM_GRADIENTS[((n || 1) - 1) % TERM_GRADIENTS.length];
};

export const chapterNumber = (chapter) => {
  const m = /^(\d+)/.exec(String(chapter || '').trim());
  return m ? parseInt(m[1], 10) : null;
};

export const chapterColor = (chapter) => {
  const n = chapterNumber(chapter);
  if (!n) return { bg: 'bg-slate-50', text: 'text-slate-800', border: 'border-slate-300', dot: 'bg-slate-400', bar: 'from-slate-400 to-slate-500' };
  return PALETTE[(n - 1) % PALETTE.length];
};
